module.exports = __webpack_public_path__ + "img/wallet.601a5615.svg";